import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Helmet from 'helmet/helmet';
import { RouteComponentProps } from 'react-router';

import { Site } from 'four-nets/site';
import LeftMenu from 'four-nets/photoblog/left-menu/left-menu';

import { MediaKey } from '../masonry/masonry';
import PopularImages from './popular-images';
import defaultStyles from './popular-images-wrapper.scss';

const columnsSizes: Map<MediaKey, number> = new Map([
    ['sm', 2],
    ['md', 3],
    ['lg', 4],
]);

interface Props extends RouteComponentProps {
    styles: typeof defaultStyles;
}

class PopularImagesWrapper extends React.PureComponent<Props, {}> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    renderHelmet = (H: React.ComponentClass) => {
        const { site } = this.context;

        return (
            <FormattedMessage id='POPULAR_IMAGES'>
                {message => (
                    <H>
                        <title>
                            {message} | {site.name}
                        </title>
                    </H>
                )}
            </FormattedMessage>
        );
    };

    render() {
        const {
            styles,
            location: { pathname },
        } = this.props;
        return (
            <React.Fragment>
                <Helmet render={this.renderHelmet} />
                <h1 className={styles.title}>
                    <FormattedMessage id='POPULAR_IMAGES' />
                </h1>
                <div className={styles.columns}>
                    <div className={styles.left}>
                        <LeftMenu />
                    </div>
                    <div className={styles.right}>
                        <PopularImages columnsSizes={columnsSizes} pathname={pathname} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(PopularImagesWrapper);
